import type {
	CommandConstructor,
	CommandProperties,
	SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * @see {@link BoeSubmitPrompt}
 */
export interface BoeSubmitPromptProperties extends CommandProperties {
	/**
	 * The user's raw prompt text from the BOE modal
	 */
	prompt: string;
	/**
	 * The whiteboard content ID to provide as context
	 */
	contentId?: string;
}

export const BoeSubmitPrompt: CommandConstructor<BoeSubmitPromptProperties, SerializableValue> =
	createCommand<BoeSubmitPromptProperties>('boe-submit-prompt');
